/**
 * Optional emergency contact block — shared by DetailsStep. Writes the
 * existing `emergencyContact` nested shape ({ name, relation, phone }), so
 * legacy patients (null) keep working unchanged.
 */
function EmergencyContactFields({ form }) {
  const { formData, handleNestedChange, formatPhone } = form;
  const contact = formData.emergencyContact || {};

  return (
    <>
      <h3 className="section-title">איש קשר לחירום</h3>

      <div className="form-row three-cols">
        <div className="form-group">
          <label>שם</label>
          <input
            type="text"
            value={contact.name || ""}
            onChange={(e) =>
              handleNestedChange("emergencyContact", "name", e.target.value)
            }
            placeholder="שם איש קשר"
          />
        </div>
        <div className="form-group">
          <label>קרבה</label>
          <input
            type="text"
            value={contact.relation || ""}
            onChange={(e) =>
              handleNestedChange("emergencyContact", "relation", e.target.value)
            }
            placeholder="למשל: דוד"
          />
        </div>
        <div className="form-group">
          <label>טלפון</label>
          <input
            type="tel"
            value={contact.phone || ""}
            onChange={(e) =>
              handleNestedChange(
                "emergencyContact",
                "phone",
                formatPhone(e.target.value)
              )
            }
            placeholder="0501234567"
            dir="ltr"
          />
        </div>
      </div>
    </>
  );
}

export default EmergencyContactFields;
